import { FETCH_BALANCE_SUCCESS } from '../actions/balanceActions';

// Backend shape: { amount_value, vip_count, plag_count, adv_count, enl_count, abs_page_count, editor_count }
// `loading` is a UI-only flag (no backend field) — starts true so
// BalancePage can render a CabinetLoadingPanel instead of flashing
// the initial "$0.00" placeholder before the real figure lands.
const initialState = {
    loading: true,
    amount_value: '0.00',
    vip_count: 0,
    plag_count: 0,
    adv_count: 0,
    enl_count: 0,
    abs_page_count: 0,
    editor_count: 0,
};

export default function balanceReducer(state = initialState, action) {
    switch (action.type) {
        case FETCH_BALANCE_SUCCESS:
            return { ...state, ...(action.payload || {}), loading: false };
        default:
            return state;
    }
}
